function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: 28,
  transform: "translate(-1318.000000, -678.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(398.000000, 565.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(762.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_demo",
  transform: "translate(158.000000, 43.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M44.65,6.78874614 L29,6.78874614 L27.2,0.688746139 C27.05,0.188746139 26.55,-0.111253861 26,0.0387461388 C25.5,0.188746139 25.2,0.738746139 25.35,1.23874614 L27,6.78874614 L20.5,6.78874614 L22.15,1.23874614 C22.3,0.738746139 22,0.188746139 21.5,0.0387461388 C21,-0.111253861 20.45,0.188746139 20.3,0.688746139 L18.5,6.78874614 L2.85,6.78874614 C1.3,6.78874614 0,8.03874614 0,9.63874614 L0,36.6387461 C0,38.1887461 1.25,39.4387461 2.85,39.4387461 L9,39.4387461 L7,46.2887461 C6.85,46.7887461 7.15,47.3387461 7.65,47.4887461 C7.75,47.5387461 7.85,47.5387461 7.9,47.5387461 C8.3,47.5387461 8.7,47.2887461 8.8,46.8387461 L10.95,39.4387461 L36.55,39.4387461 L38.7,46.8387461 C38.8,47.2387461 39.2,47.5387461 39.6,47.5387461 C39.7,47.5387461 39.8,47.5387461 39.85,47.4887461 C40.35,47.3387461 40.65,46.8387461 40.5,46.2887461 L38.5,39.4387461 L44.65,39.4387461 C46.2,39.4387461 47.5,38.1887461 47.5,36.6387461 L47.5,9.63874614 C47.5,8.03874614 46.25,6.78874614 44.65,6.78874614 Z M45.6,36.5887461 C45.6,37.0887461 45.2,37.5387461 44.65,37.5387461 L2.85,37.5387461 C2.35,37.5387461 1.9,37.1387461 1.9,36.5887461 L1.9,9.58874614 C1.9,9.08874614 2.3,8.63874614 2.85,8.63874614 L19.25,8.63874614 C19.25,8.63874614 19.25,8.63874614 19.25,8.63874614 L19.25,8.63874614 L28.25,8.63874614 C28.25,8.63874614 28.25,8.63874614 28.25,8.63874614 C28.25,8.63874614 28.25,8.63874614 28.25,8.63874614 L44.65,8.63874614 C45.15,8.63874614 45.6,9.03874614 45.6,9.58874614 L45.6,36.5887461 L45.6,36.5887461 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  d: "M29.7477967,23.9592981 L21.8015875,28.9209418 C21.5533035,29.0759713 21.2290287,28.9959955 21.0772996,28.7423109 C21.026748,28.6577907 21,28.5606581 21,28.4616051 L21,18.5383177 C21,18.241013 21.2358822,18 21.5268576,18 C21.6238019,18 21.7188667,18.0273298 21.8015875,18.078981 L29.7477967,23.0406247 C29.9960808,23.1956542 30.074354,23.5269825 29.9226249,23.7806672 C29.8790413,23.853537 29.8191153,23.9147665 29.7477967,23.9592981 Z",
  id: 111,
  stroke: "#3D84FF",
  strokeWidth: 1.9
})))))));

const SvgIcDemo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "48px",
    viewBox: "0 0 50 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDemo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-demo.b7c44c22.svg";
export { ForwardRef as ReactComponent };